import { createSlice } from "@reduxjs/toolkit";
import {
    generateMetaAds
} from "../actions/generateMetaAdsAction";
import { toast } from 'react-toastify';

const INITIAL_STATE = {
    generateMetaAds: {
        data: null,
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
}

const generateMetaAdsReducer = createSlice({
    name: "generateMetaAds",
    initialState: INITIAL_STATE,
    reducers: {

    },
    extraReducers: (builder) => {
        //------------------------------- loginAction start -------------------------
        // eslint-disable-next-line
        builder.addCase(generateMetaAds.fulfilled, (state, action) => {
            if(action.payload){
                state.generateMetaAds.data = action.payload.data;
                state.generateMetaAds.apiMsg.status = action.meta.requestStatus;
                state.generateMetaAds.apiMsg.message = action.payload.message.message;

                toast.success(action.payload.message.message, {
                    position: "bottom-center",
                    toastId: "success"
                });
            }
           


        });

        builder.addCase(generateMetaAds.pending, (state, action) => {
            state.generateMetaAds.data = null;
            state.generateMetaAds.apiMsg.status = action.meta.requestStatus;
            

        });
        builder.addCase(generateMetaAds.rejected, (state, action) => {

            state.generateMetaAds.data = null;
            state.generateMetaAds.apiMsg.status = action.meta.requestStatus;
            if (action.payload && action.payload.message && action.payload.message.message) {
                state.generateMetaAds.apiMsg.message = action.payload.message.message;
            }


            toast.error(action.error.message ? action.error.message : "Something went wrong please try again", {
                position: "bottom-center",
                toastId: "error"
            });
        });


    }
});

export const { } = generateMetaAdsReducer.actions;
export default generateMetaAdsReducer.reducer;
